import { NavigationTranslationType, ProfileTranslationType, ErrorsTranslationType, CommonTranslationType } from "../../features/types";

// Remove nested structure type and export a flatter object structure
export const common = {
  navigation: {
    dashboard: "Nadzorna plošča",
    profile: "Profil",
    signOut: "Odjava"
  },
  profile: {
    title: "Profil",
    dangerZone: "Nevarno območje",
    deleteAccount: "Izbriši račun",
    confirmDelete: "Potrdi izbris",
    deleteWarning: "Ali ste prepričani, da želite izbrisati svoj račun? Tega dejanja ni mogoče razveljaviti.",
    confirmDeleteButton: "Izbriši račun",
    accountDeleted: "Račun izbrisan",
    accountDeletedMessage: "Vaš račun je bil uspešno izbrisan."
  },
  // Make this a direct property instead of nested
  cancel: "Prekliči",
  delete: "Izbriši",
  deleteConfirmation: "Potrditev izbrisa",
  deleteConfirmationMessage: "Ali ste prepričani, da želite izbrisati",
  confirm: "Potrdi",
  errors: {
    error: "Napaka",
    notFound: "Stran ni bila najdena",
    deleteAccountError: "Pri brisanju vašega računa je prišlo do napake. Prosimo, poskusite znova.",
    loadStoryError: "Pri nalaganju zgodbe je prišlo do napake. Prosimo, poskusite znova.",
    loadCharactersError: "Pri nalaganju likov je prišlo do napake. Prosimo, poskusite znova.",
    summaryError: "Pri ustvarjanju povzetka je prišlo do napake. Prosimo, poskusite znova."
  }
};
